export const InvalidLabelClass = 'is-invalid';
export const InvalidFeedbackClass = 'invalid-feedback';
